import "./TechnicalIndicatorsComponent.scss";
import {IComponentOptions} from "angular";
import {SecurityTradingSystemIndicators} from "../../models/SecurityTradingSystemIndicators";
import {ComponentCallback} from "../../../types/AngularJS";
import {TradingSystemStatus} from "../../models/TradingSystemStatus";
import {LittDirection} from "../../models/LittDirection";
import {TechnicalStatistics} from "../../models/TechnicalStatistics";

export const TechnicalIndicators = "tfTechnicalIndicators";

export function technicalIndicators(): IComponentOptions {
    return {
        templateUrl: "app/trading-systems/components/technical-indicators/TechnicalIndicatorsComponent.html",
        bindings: {
            tradingSystem: "<",
            onSelectLitt: "&"
        },
        controllerAs: "ctrl",
        controller: TechnicalIndicatorsComponent
    };
}

export class TechnicalIndicatorsComponent {

    public set tradingSystem(system: SecurityTradingSystemIndicators | null) {
        if (system == null || system.littDirection == null) {
            return;
        }
        if (system.littDirection === LittDirection.SHORT) {
            this.littShortStatus = system.littStatus;
            this.littLongStatus = TradingSystemStatus.INACTIVE;
        } else {
            this.littShortStatus = TradingSystemStatus.INACTIVE;
            this.littLongStatus = system.littStatus;
        }
        this.code = system.code;
        this.statistics = system.statistics;
    }

    public code: string;
    public littShortStatus = TradingSystemStatus.INACTIVE;
    public littLongStatus = TradingSystemStatus.INACTIVE;
    public statistics: TechnicalStatistics;

    public onSelectLitt: ComponentCallback;

    public selectLittLong() {
        const littLong: SecurityTradingSystemIndicators = {
            code: this.code,
            ironCondorStatus: TradingSystemStatus.INACTIVE,
            littDirection: LittDirection.LONG,
            littStatus: this.littLongStatus,
            statistics: this.statistics
        };

        this.onSelectLitt({system: littLong});
    }

    public selectLittShort() {
        const littShort: SecurityTradingSystemIndicators = {
            code: this.code,
            ironCondorStatus: TradingSystemStatus.INACTIVE,
            littDirection: LittDirection.SHORT,
            littStatus: this.littShortStatus,
            statistics: this.statistics
        };

        this.onSelectLitt({system: littShort});
    }
}
